"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInterval = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
/**
 * Use interval in component
 *
 * @param fn {() => void | Promise<void>} - callback function
 * @param time {number} - timeout
 */
function useInterval(fn, time) {
    react_1.default.useEffect(function () {
        var timeout = setInterval(fn, time);
        return function cleanup() {
            clearInterval(timeout);
        };
    }, []);
}
exports.useInterval = useInterval;
//# sourceMappingURL=use-interval.js.map